export const getImageUrl = (language: string): string => {
  switch (language) {
    case "ja":
      return "img/japanese";
    default:
      return "img";
  }
};
